import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    height: '45px',
    marginBottom: '20px'
  },
  primaryFilter: {
    height: '69px',
    marginBottom: '10px'
  },
  secondaryFilter: {
    height: '69px',
    marginBottom: '20px'
  },
  map: {
    height: '389px',
    marginBottom: '10px'
  }
};

const SkeletonInteractiveMapMobile = (props) => {
  const [className, style] = useStyles(props);
  const { header, primaryFilter, secondaryFilter, map } = styles;
  return (
    <Box
      className={`${className} ${SkeletonInteractiveMapMobile.componentName} fr-skeleton`}
      style={style}
    >
      <Row gutters>
        <Col className={`${SkeletonInteractiveMapMobile.componentName} fr-skeleton-header`} xs="12">
          <Box className="fr-skeleton-element" style={header} />
        </Col>
        <Col
          className={`${SkeletonInteractiveMapMobile.componentName} fr-skeleton-primary-filters`}
          xs="12"
        >
          <Box className="fr-skeleton-element" style={primaryFilter} />
        </Col>
        <Col
          className={`${SkeletonInteractiveMapMobile.componentName} fr-skeleton-secondary-filters`}
          xs="12"
        >
          <Box className="fr-skeleton-element" style={secondaryFilter} />
        </Col>
        <Col className={`${SkeletonInteractiveMapMobile.componentName} fr-skeleton-map`} xs="12">
          <Box className="fr-skeleton-element" style={map} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonInteractiveMapMobile.componentName = 'SkeletonInteractiveMapMobile';

export default SkeletonInteractiveMapMobile;
